import { BASE_URL } from 'config'

import {
  NO,
  YES,
  NEW_SCENARIO,
  CLONE_SCENARIO,
  ENUM_SCENARIO_TYPE,
  HIDDEN
} from 'components/Wizard/constants'
import {
  isArray,
  isEmpty,
  isNull,
  isObject,
  isString,
  isUndefined,
  keys
} from 'lodash'
import { getDateTimeISO } from './date'
import { getDataString } from './recap'
import { wizardStore } from 'services/state'

const formatDates = (items, inputElements, status) => {
  return Object.keys(items).reduce((acc, key) => {
    const isHidden = status[key]?.some(({ state }) => state === HIDDEN)

    if (isHidden) return acc

    if (['date', 'datetime'].includes(inputElements[key]?.type)) {
      return {
        ...acc,
        [key]: getDateTimeISO(items[key], inputElements[key]?.type)
      }
    }

    return { ...acc, [key]: items[key] }
  }, {})
}

export const generateCreationObject = ({
  t,
  status,
  username,
  formData,
  cloneInfo,
  flattenValues,
  inputElements,
  creationValues,
  formatOptions,
  documentFilters,
  scenarioSummary
}) => {
  const { name, type, creationMode, notes, instanceId } = creationValues

  const filter = {
    documentFilters,
    instance: instanceId
  }

  const summary = scenarioSummary
    .map(({ label, element }) => {
      const errorsFlags = []

      if (isArray(element)) {
        // Element may be an array of keys, so we need to check if all of them match in inputElements
        element.forEach((key) => {
          if (isNull(inputElements[key]) || isUndefined(inputElements[key])) {
            errorsFlags.push(true)
          } else errorsFlags.push(false)
        })
      } else {
        if (
          isNull(inputElements[element]) ||
          isUndefined(inputElements[element])
        ) {
          return null
        }
      }

      if (errorsFlags.some((val) => val)) return null

      return {
        key: label,
        value: isString(element)
          ? getDataString({
              t,
              summary: true,
              value: flattenValues[element],
              type: inputElements[element].type,
              formatOptions
            })
          : element
              .map((item) =>
                getDataString({
                  t,
                  summary: true,
                  value: flattenValues[item],
                  type: inputElements[item].type,
                  formatOptions
                })
              )
              .join(' ')
      }
    })
    .filter((el) => !isEmpty(el))
    .map(({ value, key }) => ({
      key,
      value: isObject(value) ? value?.label || value?.value || '' : value
    }))

  const formattedData = formatDates(formData, inputElements, status)

  const data = {
    ...formattedData,
    title: name,
    scenarioName: name,
    scenarioDescription: notes,
    scenarioTypeEnumName: ENUM_SCENARIO_TYPE,
    scenarioTypeEnumValue: type,
    scenarioIsNew: creationMode === NEW_SCENARIO ? YES : NO
  }

  let scenarioManager = {
    name,
    summary,
    username,
    type: {
      name: ENUM_SCENARIO_TYPE,
      value: type
    },
    cloned: creationMode === CLONE_SCENARIO,
    notes
  }

  if (!isEmpty(cloneInfo)) {
    scenarioManager = {
      ...scenarioManager,
      ...cloneInfo
    }
  }

  const body = {
    filter,
    scenarioManager,
    data
  }

  return body
}

export const getPayloadMapperList = (data) => {
  if (isEmpty(data)) return null
  return keys(data).map((key) => ({
    fieldToMap: `data.${key}`,
    valueToMap: data[key]
  }))
}

export const processedScheduledData = ({
  scheduledData,
  scenarioResult,
  payloadMapper,
  isScheduledEditing
}) => {
  const { jobType, cronStart, cronEnd, enabled, mailTo, cronExp, timezone } =
    scheduledData
  const { data, scenarioManager } = scenarioResult

  return {
    scenarioScheduleName: data.scenarioName,
    scenarioJobName: jobType,
    instanceId: scenarioManager.parent,
    instanceName: scenarioManager.parentName,
    scenarioType: scenarioManager?.type?.value,
    cronStart,
    cronEnd,
    enabled,
    timeZone: timezone,
    mails: mailTo,
    payloadMapper: isScheduledEditing
      ? payloadMapper
      : getPayloadMapperList(payloadMapper),
    payload: scenarioResult,
    httpMethod: 'POST',
    cronExp,
    url: `${BASE_URL}/scenarios`,
    summary: scenarioManager.summary.reduce(
      (acc, inc) => ({ ...acc, [inc.key]: inc.value }),
      {}
    )
  }
}

export const updatePayloadMapper = (id, value) => {
  wizardStore.update((prev) => ({
    ...prev,
    payloadMapper: { ...prev.payloadMapper, [id]: value }
  }))
}
